import React from 'react'
import '../Assets/WebsiteCss/webfooter.css'
import { Col, Container, Row, Button } from 'react-bootstrap'
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { IoLogoYoutube } from 'react-icons/io';

import { useNavigate } from 'react-router-dom';


export default function WebFooter() {
  const navigate = useNavigate();

  return (
    <>

      <Col lg={12}>
        <div className="p-1 footer-bg">
          <div className="slider-overlay"></div>
          <Container>
            <Row className='mt-3'>
              <Col lg={4}  >
                <h5 className='text-white'> Office</h5>
                <div className='d-flex '>
                  <span><FaLocationDot color='white' /></span>
                  <p className='text-white ms-2' style={{cursor:'pointer'}}>
                    Bhilwara, 311001, Rajasthan, India
                  </p>
                </div>



                <div className='mb-2 '>
                  <a
                    href="https://wa.me/919257781777"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <span className='text-white'>

                      <FaMobileAlt color='white' />  +91 9257781777 

                    </span>
                  </a>



                </div>



                <div className='d-flex '>
                  <a
                    href="mailto:info@karigarindia.in"
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span className='text-white'>
                      < MdEmail color='white' />  info@karigarindia.in
                    </span>
                  </a>

                </div>


              </Col>

              <Col lg={2} className='quickLink'>
                <h5 className='text-white'>Quick Link</h5>

                <ul>
                  <li className='text-white mb-1' onClick={() => navigate('/')} style={{ cursor: 'pointer', listStyle: 'none'}} >
                    Home
                  </li>

                  <li className='text-white mb-1' onClick={() => navigate('/aboutus')} style={{ cursor: 'pointer', listStyle: 'none' }} >About Us</li>

                  <li className='text-white mb-1' onClick={() => navigate('/services')} style={{ cursor: 'pointer', listStyle: 'none' }}>Services</li>

                  <li className='text-white mb-1' onClick={() => navigate('/ourproducts')} style={{ cursor: 'pointer', listStyle: 'none' }}>Products</li>

                  <li className='text-white mb-1' onClick={() => navigate('/contact')} style={{ cursor: 'pointer', listStyle: 'none' }}>Contact Us</li>
                </ul>
              </Col>

              <Col lg={2}>
                <h5 className='text-white'>Policy</h5>


                <p className='text-white' onClick={() => navigate('/privacypolicy')} style={{ cursor: 'pointer' }}>
                  Privacy Policy
                </p>

                <p className='text-white' onClick={() => navigate('/termcondition')} style={{ cursor: 'pointer' }} >Term & Conditions</p>


              </Col>



              <Col lg={4}>
                <h5 className='text-white'>Connect With us</h5>
                <p className='text-white' >
                  We’re always looking to connect with tose who share an interest
                  in a sustainable future.
                </p>

                <div className="d-flex">
                  <Button onClick={() => navigate('/contact')}>Contact Us</Button>
                  {/* <a
                    className="iconback"
                    href="https://www.facebook.com/salvibhojmal/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Visit Karigar Namkeen Facebook profile"
                  >
                    <FaFacebookF />
                  </a>

                  <a
                    className="iconback mx-3"
                    href="https://youtube.com/@bhojmalsalvi"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Visit YouTube Channel"
                  >
                    <IoLogoYoutube />
                  </a> */}

                  {/* <a
                    className="iconback me-3"
                    href="https://www.linkedin.com/in/narayan-salvi-68007375/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Visit LinkedIn Profile"
                  >
                    <FaLinkedinIn />
                  </a> */}

                  {/* <a
                    className="iconback"
                    href="https://www.instagram.com/namkeen_labour_contractor/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Visit Instagram Profile"
                  > 
                    <FaInstagram />
                  </a>*/}
                </div>

              </Col>
            </Row>

            <div className='text-white mt-3 footerend text-center'>
              <hr />
              <p>© {new Date().getFullYear()}Karigar India Namkeen Labour Contractor.
                {/* <a href="https://www.bighostindia.in/" style={{color:'white',textDecoration:'none'}}>Design By : BigHost India Private Limited</a>  */}
              </p>
            </div>
          </Container>
        </div>
      </Col>


    </>
  )
}
